import React from "react";
import ReactTable from "../../../AppComponent/Table";
import completed_icons from "../../../../Assets/AppComponent/new_dashboard/completed_icons.svg";
import decline_icons from "../../../../Assets/AppComponent/new_dashboard/decline_icon.svg";
import AttendanceGraph from "./AttendanceGraph";

const Attendancedetails = () => {
  const columns = [
    {
      Header: "Position",
      accessor: "position",
    },
    {
      Header: "State",
      accessor: "state",
    },
    {
      Header: "Percentage",
      accessor: "percentage",
    },
  ];

  // STATIC DATA
  const data = [
    { position: "01", state: "Tamilnadu", percentage: "60%" },
    { position: "02", state: "Karnataka", percentage: "40%" },
    { position: "03", state: "Kerala", percentage: "30%" },
    { position: "04", state: "Maharastra", percentage: "25%" },
    { position: "05", state: "Telugana", percentage: "20%" },
  ];

  return (
    <div className="attendance-panel">
      <h5>ATTENDANCE</h5>

      <div className="att-box">
        <div className="item">
          <p>
            Present <img src={completed_icons} alt="present" />
          </p>
          <h3>400</h3>
        </div>

        <div className="divider"></div>

        <div className="item">
          <p>
            Absent <img src={decline_icons} alt="absent" />
          </p>
          <h3>20</h3>
        </div>
      </div>
      {/* <div className="table-section">
        <h5>All TOP ABSENTEES</h5>
        <ReactTable data={data} columns={columns} />
      </div> */}
      <div className="table-section">
        <AttendanceGraph />
      </div>
    </div>
  );
};

export default Attendancedetails;
